import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-action-button"
    }}>{`sp-action-button`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders an action button.`}</p>
    <p><img alt="Action Buttons" src={require("../assets/sp-action-button.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/action-button/"
        }}>{`https://spectrum.adobe.com/page/action-button/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/action-button"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/action-button`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-action-button>An Action</sp-action-button>
`}</code></pre>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`There are several variations that are supported.`}</p>
    <h3 {...{
      "id": "disabled"
    }}>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-action-button disabled>Disabled</sp-action-button>
`}</code></pre>
    <h3 {...{
      "id": "quiet"
    }}>{`Quiet`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-action-button quiet>A quiet button</sp-action-button>
`}</code></pre>
    <h3 {...{
      "id": "with-icon"
    }}>{`With icon`}</h3>
    <h4 {...{
      "id": "built-in-svg-icon"
    }}>{`Built-in SVG icon`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-action-button>
    <sp-icon name="ui:Magnifier" size="xs" slot="icon"></sp-icon>
    Zoom
</sp-action-button>
`}</code></pre>
    <h4 {...{
      "id": "custom-svg-icon"
    }}>{`Custom SVG icon`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-action-button>
    <div slot="icon" style="fill: currentColor">
        <svg viewBox="0 0 36 36" style="width: 18px; height: 18px;">
            <path d="M33.567 8.2L27.8 2.432a1.215 1.215 0 0 0-.866-.353H26.9a1.371 1.371 0 0 0-.927.406L5.084 23.372a.99.99 0 0 0-.251.422L2.055 33.1c-.114.377.459.851.783.851a.251.251 0 0 0 .062-.007c.276-.063 7.866-2.344 9.311-2.778a.972.972 0 0 0 .414-.249l20.888-20.889a1.372 1.372 0 0 0 .4-.883 1.221 1.221 0 0 0-.346-.945zM11.4 29.316c-2.161.649-4.862 1.465-6.729 2.022l2.009-6.73z"/>
        </svg>
    </div>
    Edit Text
</sp-action-button>
`}</code></pre>
    <h3 {...{
      "id": "icon-only"
    }}>{`Icon only`}</h3>
    <h4 {...{
      "id": "built-in-svg-icon-1"
    }}>{`Built-in SVG icon`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-action-button style="padding: 0; max-width: 32px; max-height: 32px;">
    <sp-icon name="ui:Magnifier" size="s" slot="icon"></sp-icon>
</sp-action-button>
`}</code></pre>
    <h4 {...{
      "id": "custom-svg-icon-1"
    }}>{`Custom SVG icon`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-action-button style="padding: 0; max-width: 32px; max-height: 32px;">
    <div slot="icon" style="fill: currentColor">
        <svg viewBox="0 0 36 36" style="width: 18px; height: 18px;">
            <path d="M33.567 8.2L27.8 2.432a1.215 1.215 0 0 0-.866-.353H26.9a1.371 1.371 0 0 0-.927.406L5.084 23.372a.99.99 0 0 0-.251.422L2.055 33.1c-.114.377.459.851.783.851a.251.251 0 0 0 .062-.007c.276-.063 7.866-2.344 9.311-2.778a.972.972 0 0 0 .414-.249l20.888-20.889a1.372 1.372 0 0 0 .4-.883 1.221 1.221 0 0 0-.346-.945zM11.4 29.316c-2.161.649-4.862 1.465-6.729 2.022l2.009-6.73z"/>
        </svg>
    </div>
</sp-action-button>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to a click on the action button using the `}<inlineCode parentName="p">{`click`}</inlineCode>{` event.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourActionButton").addEventListener("click", evt => {
    console.log("Action Button clicked");
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      